import React, {FunctionComponent} from 'react'
import {useQueries} from '../../../utils/hooks/useQueries'
import ContactsDesktop from './ContactsDesktop'
import ContactsMobile from './ContactsMobile'

const ContactsPage: FunctionComponent = () => {
    const {isMobile} = useQueries()

    return isMobile ?
        <ContactsMobile/> :
        <ContactsDesktop/>
}

export default ContactsPage
